import React, { PropsWithChildren, forwardRef } from 'react'

import { PhotoViewerNoticeContainer } from 'components/page/PhotoViewer/PhotoViewer.styled'

import { photoViewerNoticeDataName } from './PhotoViewerNotice.constants'

export const PhotoViewerNoticeView = forwardRef<
  HTMLDivElement,
  PropsWithChildren
>(({ children }, ref) => {
  return (
    <PhotoViewerNoticeContainer ref={ref} data-name={photoViewerNoticeDataName}>
      {children}
    </PhotoViewerNoticeContainer>
  )
})
